import {ConnecttocrudService} from '../../connecttocrud.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {ConfService} from '../../conf.service';
import {NestedTreeControl} from '../../../../node_modules/@angular/cdk/tree';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

declare let $;

export interface ConfirmReplaceRecordData {
    data: any;
}

@Component({
    selector: 'app-edit',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {
    id: string;
    item = [];
    columns: string[] = [];
    partner: string;
    account: string;
    entity: string;
    version: string;
    partnerKey: string;
    attributes: any;
    arrayOfStrings = false;
    userView = 'json';
    options1 = new JsonEditorOptions();
    options = new JsonEditorOptions();
    idBeingEdited: any;
    DBRefView = false;
    color = 'orange';
    checked = false;
    disabled = false;
    apiByDefinition: any;
    showDBRef: boolean;
    loading = false;
    loading1 = false;

    @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
    treeControl = new NestedTreeControl<any>(node => this.constructKeyValue(Object.values(node)[1])
    );
    dataSource: any;
    dataSource1: any;

    hasChild = (_: number, node: any) => !!this.typeOfval(Object.values(node)[1]);

    constructor(private _route: ActivatedRoute,
                private _service: ConnecttocrudService,
                public snackBar: MatSnackBar,
                private appComp: AppComponent,
                private confPost: ConfService,
                public platform: LeftpanelComponent,
                public dialog: MatDialog) {
        this.options1.mode = 'code';
        this.options1.modes = ['code', 'text', 'tree', 'view'];
        this.options1.schema = '';
        this.options1.statusBar = false;
        this.options1.onChange = () => console.log(/*this.editor.get()*/);




        // this.options = {
        //         mode: 'code',
        //         modes: ['text', 'code', 'tree'],
        //         onEditable: function () {
        //             return {field: false, value: false};
        //         }
        //     };
    }

    toggleView() {
        this.DBRefView = !this.DBRefView;
    }

    getitemvalues(): any {
        this.id = this._route.snapshot.paramMap.get('id');
        this._service.getItemById(this.id, this.version, this.partner, this.account, this.entity).subscribe(
            item => {
                this.dataSource = item[0];
            },
            error => {
                this.platform.handleErrorGracefully(error, 'Error while getting items values. Please try after sometime.');
                // this.platform.openSnackBar('Error while getting items' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            }
        );
        this._service.getItemByIdWithNoDBRef(this.id, this.version, this.partner, this.account, this.entity).subscribe(
            item => {
                this.dataSource1 = item[0];
            },
            error => {
                this.platform.handleErrorGracefully(error, 'Error while getting item. Please try after sometime.');
                // this.platform.openSnackBar('Error while getting item' + (error !== null && error !== undefined && error.error !== null && error.error !== undefined) ? ': ' + error.error.message : '', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            }
        );
        /*this.confPost.getPartner(localStorage.getItem('partner')).subscribe( items => {
            items.accounts.forEach((data) => {
                if (data.account == this.account) {
                    data.entities.forEach((entity) => {
                        if (entity.entityname == this.entity) {
                            this.attributes = entity.attributes;
                            // this.version = entity.version;
                        }
                    });
                }
            });
        });*/
    }

    getValue(val) {
        return Object.values(val);
    }

    getKey(val) {
        return Object.keys(val);
    }

    constructKeyValue(val) {
        const array = [];
        if (val != null) {
            const value = val[0];
            for (const val1 in value) {
                const keyVal = {};
                keyVal['key'] = val1;
                keyVal ['value'] = val[0][val1];
                array.push(keyVal);
            }
            return array;
        } else {
            return null;
        }
    }
    getFinalValue(val) {
        let value;
        if (val.startsWith('{')) {
            value = JSON.parse(val);
        } else {
            value = val;
        }
        return value;
    }

    getLeaf(event) {
        const that = this;
        const leafArray = [];
        const leafObj = {};
        $(event).children('li').children('ul').children('mat-tree-node').each(function () {
            leafObj[$(this).find('li').find('table').find('tr td:eq(0)').text()] =
                that.getFinalValue($(this).find('li').find('table').find('tr td:eq(1) input').val());
        });
        leafArray.push(leafObj);
        return leafArray;
    }

    treeNode(event) {
        const that = this;
        const nestedTree = [];
        const parentObj = {};
        $(event).children('mat-nested-tree-node').each(function () {
            let nested, leaf;
            parentObj[$(this).children('li').children('div').find('td').text()] = [];
            if ($(this).children('li').children('ul').children('mat-nested-tree-node').length > 0) {
                nested = that.treeNode($(this).children('li').children('ul'));
            }
            if ($(this).children('li').children('ul').children('mat-tree-node').length > 0) {
                leaf = that.getLeaf($(this));
            }
            parentObj[$(this).children('li').children('div').find('td').text()].push(Object.assign((nested ? nested[0] : {}), (leaf ? leaf[0] : {})));
            nestedTree.push(parentObj);
        });
        return nestedTree;
    }

    saveData(): void {
        const that = this;
        const parent = [];
        const parentObj = {};
        $('mat-tree').children('mat-tree-node').each(function () {
            parentObj[$(this).find('li').find('table').find('tr td:eq(0)').text()] =
                that.getFinalValue($(this).find('li').find('table').find('tr td:eq(1) input').val());
        });
        $('mat-tree').children('mat-nested-tree-node').each(function () {
            let nested, leaf;
            parentObj[$(this).children('li').children('div').find('td').text()] = [];
            if ($(this).children('li').children('ul').children('mat-nested-tree-node').length > 0) {
                nested = that.treeNode($(this).children('li').children('ul'));
            }
            if ($(this).children('li').children('ul').children('mat-tree-node').length > 0) {
                leaf = that.getLeaf($(this));
            }
            parentObj[$(this).children('li').children('div').find('td').text()].push(Object.assign((nested ? nested[0] : {}), (leaf ? leaf[0] : {})));
        });
        parent.push(parentObj);
        parentObj['id'] = this.dataSource.id;

        this.id = this._route.snapshot.paramMap.get('id');
        this._service.postItemUpdate(this.id, parentObj, this.version, this.partner, this.account, this.entity).subscribe(
            status => {
                this.platform.openSnackBar('Data updated successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            },
            error => {
                this.platform.handleErrorGracefully(error, 'Something went wrong. Please try after sometime.');
                // this.platform.openSnackBar('Something went wrong. Please try after sometime', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            });
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.appComp.currentPageTitle = 'Update Record';
        this._route.queryParams
            .subscribe(params => {
                this.partner = params.partner;
                this.account = params.account;
                this.entity = params.entity;
                this.version = params.version;
                this.partnerKey = localStorage.getItem('partnerKey');
                this.confPost.getEntity(params.partner, params.account, params.entity, params.version).subscribe(data => {
                    this.apiByDefinition = data;
                    if (this.apiByDefinition.database.toLowerCase() === 'default' || this.apiByDefinition.database.toLowerCase() === 'mongodb') {
                        this.showDBRef = true;
                    } else {
                        this.showDBRef = false;
                    }
                }, error => {
                    this.platform.handleErrorGracefully(error, 'Error while retrieving entity. Please try after sometime.');
                });
            });
        this.getitemvalues();
        if (this.editor) {
            this.editor.setDisabledState(true);
        }
    }

    typeOfval(val) {
        let value;
        this.arrayOfStrings = false;
        if (val instanceof Array) {
            if (val.length > 0 && val[0] instanceof Object) {
                value = true;
            } else {
                value = false;
            }
        } else {
            value = false;
        }
        return value;
    }

    getValueType(val) {
        let value;
        if (val instanceof Array) {
            if (val.length > 0 && val[0] instanceof Object) {
                value = false;
            } else {
                value = true;
            }
        } else {
            value = false;
        }
        return value;
    }
    getNodeValue(val) {
        let value;
        if (val instanceof Object) {
            value = this.stringifyjson(val);
        } else {
            value = val;
        }
        return value;
    }

    stringifyjson(val) {
        return JSON.stringify(val);
    }

    openDialog() {
        const data = {};
        const dialogRef1 = this.dialog.open(ConfirmReplaceRecordComponent, {
            width: '40%',
            height: '40%',
            data: data
        });
        dialogRef1.afterClosed().subscribe(response2 => {
            if (response2 === 'yes') {
                this.replaceJSONData();
            } else {

            }
        });
    }

    replaceJSONData() {
        this.loading1 = true;
        const data = this.editor.get();
        this.id = this._route.snapshot.paramMap.get('id');
        // data['id'] = this.dataSource.id;
        //data['id']
        this._service.postItemUpdate(this.id, data, this.version, this.partner, this.account, this.entity).subscribe(
            status => {
                this.loading1 = false;
                this.platform.openSnackBar('Data updated successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            },
            error => {
                this.loading1 = false;
                this.platform.handleErrorGracefully(error, 'Something went wrong. Please try after sometime.');
                // this.platform.openSnackBar('Something went wrong. Please try after sometime', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            });
    }

    patchJSONData() {
        this.loading = true;
        const data = this.editor.get();
        this.id = this._route.snapshot.paramMap.get('id');
        // data['id'] = this.dataSource.id;
        //data['id']
        this._service.patchItemUpdate(this.id, data, this.version, this.partner, this.account, this.entity).subscribe(
            status => {
                this.loading = false;
                this.platform.openSnackBar('Data updated successfully', 'Success', {
                    duration: 5000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            },
            error => {
                this.loading = false;
                this.platform.handleErrorGracefully(error, 'Something went wrong. Please try after sometime.');
                // this.platform.openSnackBar('Something went wrong. Please try after sometime', 'Error', {
                //     duration: 5000,
                //     verticalPosition: 'top',
                //     horizontalPosition: 'center'
                // });
            });
    }

}

@Component({
    selector: 'confirmReplaceRecord',
    templateUrl: 'confirmReplaceRecord.component.html',
//     styleUrls: ['dialog-overview-example.css'],
})
export class ConfirmReplaceRecordComponent {

    constructor(
        public dialogRef: MatDialogRef<ConfirmReplaceRecordComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmReplaceRecordData) {
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
